// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2I9AN","checkboxCol":"Table_checkboxCol__293-r","emailCol":"Table_emailCol__2awq3","actionCol":"Table_actionCol__68vpO"};